import type {SuggestRequest, SuggestResponse, SuggestType, SuggestValue} from '@yandex-delivery/blocks'
import {externalApiURL} from '@yandex-delivery/client-core/api/corp'
import type {
  LocationDetect,
  LocationDetectedVariant,
  LocationDetectResult,
} from '@yandex-delivery/types/logistic-dispatcher/external-api'
import {addQuery, defaultTo, flow, get, pipe, stubArray, uniqueId} from '@yandex-delivery/utils'

import {DEFAULT_CITIES} from '../../constants/defaultCities'
import type {FetchFunction} from '../fetch'

export type LocationRequest = SuggestRequest<LocationDetectedVariant>
export type LocationResponse = SuggestResponse<LocationDetectedVariant[], LocationDetectedVariant>

export function fetchDetectLocationByCity(
  params: LocationRequest,
  fetch: FetchFunction,
  countryCode: string,
): Promise<LocationResponse> {
  const {text = '', __origin} = params
  const requestLocation: LocationDetect['location'] = text ? text : pipe(__origin, get('address'), defaultTo(''))
  const isDefaultCityFilled = DEFAULT_CITIES.some(
    defaultCountry => defaultCountry.address.toLowerCase() === text.toLowerCase(),
  )

  // Устанавливаем дефолтные значения
  if (requestLocation === '' || isDefaultCityFilled) {
    return Promise.resolve({
      type: 'final',
      suggest: DEFAULT_CITIES.map(toSuggestValue),
      __origin: DEFAULT_CITIES,
    })
  }

  return fetch<LocationDetect, LocationDetectResult, LocationDetectResult>({
    url: addQuery(externalApiURL('/platform/location/detect'), {country: countryCode}),
    method: 'POST',
    body: {
      location: requestLocation,
    },
  })
    .then(getVariants)
    .then(result => ({
      type: 'final' as SuggestType,
      __origin: result,
      suggest: result.map(toSuggestValue),
    }))
    .catch(() => ({
      type: 'final' as SuggestType,
      __origin: __origin ? [__origin] : [],
      suggest: __origin ? [toSuggestValue(__origin)] : [],
    }))
}

const toSuggestValue = (item: LocationDetectedVariant): SuggestValue<LocationDetectedVariant> => ({
  id: uniqueId('suggest-point'),
  title: item.address,
  __origin: item,
})
const getVariants = flow(get('variants'), defaultTo(stubArray()))
